import React from 'react';
import styled from 'styled-components';
import { animated } from 'react-spring';

import { Header } from '../Header';

import { breakpoints } from '../../constants';

interface IProps {
    className?: string;
    style?: React.CSSProperties;
}

export const BaseTestHeader: React.FC<IProps> = ({
    className,
    style,
    children,
}) => (
    <animated.div className={className} style={style}>
        <Header>{children}</Header>
    </animated.div>
);

export const TestHeader = styled(BaseTestHeader)`
    ${Header} {
        font-size: 18px;
    }

    @media (${breakpoints.mediumMin}) {
        ${Header} {
            font-size: 28px;
        }
    }

    @media (${breakpoints.largeMin}) {
        ${Header} {
            font-size: 34px;
        }
    }
`;
